import apiClient from './client';

// ── Types ─────────────────────────────────────────────────────────────────────

export type AuditStatus = 'pending' | 'running' | 'completed' | 'failed' | 'cancelled';
export type AuditSeverity = 'critical' | 'warning' | 'info';
export type AuditTypeValue = 'basic' | 'seo' | 'product' | 'homepage' | 'trust' | 'performance' | 'accessibility';

export interface AuditResult {
  id: number;
  audit_type: AuditTypeValue;
  check_key: string;
  title: string;
  description: string;
  severity: AuditSeverity;
  severity_label: string;
  passed: boolean;
  value: unknown;
  recommendation: string | null;
}

export interface StoreAuditRun {
  id: number;
  status: AuditStatus;
  status_label: string;
  audit_types: AuditTypeValue[];
  score: number | null;
  score_label: string;
  total_checks: number;
  passed_checks: number;
  failed_checks: number;
  pass_rate: number;
  error_message: string | null;
  started_at: string | null;
  completed_at: string | null;
  created_at: string | null;
  results?: AuditResult[];
}

export interface AuditListResponse {
  success: boolean;
  data: StoreAuditRun[];
  meta: {
    current_page: number;
    last_page: number;
    per_page: number;
    total: number;
  };
}

export interface LatestAuditResponse {
  success: boolean;
  data: {
    run: StoreAuditRun;
    remaining: number;
  };
}

export interface TriggerAuditPayload {
  types?: AuditTypeValue[];
}

// ── API calls ─────────────────────────────────────────────────────────────────

export const storeAuditApi = {
  list(page = 1): Promise<AuditListResponse> {
    return apiClient.get('/store-audits', { params: { page } }).then((r) => r.data);
  },

  trigger(payload: TriggerAuditPayload = {}): Promise<{ success: boolean; data: StoreAuditRun }> {
    return apiClient.post('/store-audits', payload).then((r) => r.data);
  },

  latest(): Promise<LatestAuditResponse> {
    return apiClient.get('/store-audits/latest').then((r) => r.data);
  },

  find(id: number): Promise<{ success: boolean; data: StoreAuditRun }> {
    return apiClient.get(`/store-audits/${id}`).then((r) => r.data);
  },
};
